import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';

import { ModalType } from '@connect-services/client/components/abstract-modal/abstract-modal.component';
import { ConfirmationModal } from '@connect-services/client/components/confirmation-modal/confirmation-modal.component';
import { ModalResultEnum } from '@connect-services/client/models/common.model';

@Injectable({
    providedIn: 'root',
})
export class EditModeDeleteModalService {
    private readonly dialog = inject(MatDialog);
    private readonly translocoService = inject(TranslocoService);

    public openDeleteEntitiesDialog(selectedCount: number): Promise<boolean> {
        if (!selectedCount) {
            return Promise.resolve(false);
        }

        const descriptionBase = this.translocoService.translate('editMode.deleteSelectionDescription', {
            COUNT: selectedCount,
        });

        const warningText = this.translocoService.translate('editMode.deleteSelectionWarning');
        const description = `${selectedCount} ${descriptionBase} \n\n ${warningText}`;

        const dialogRef = this.dialog.open(ConfirmationModal, {
            autoFocus: false,
            data: {
                cancelLabel: this.translocoService.translate('cancel'),
                confirmLabel: this.translocoService.translate('delete'),
                description,
                title: this.translocoService.translate('editMode.deleteSelectionTitle', { COUNT: selectedCount }),
                type: ModalType.DANGER,
            },
            disableClose: true,
            restoreFocus: false,
            width: '36rem',
        });

        return new Promise<boolean>((resolve) => {
            dialogRef.afterClosed().subscribe((result: ModalResultEnum) => {
                resolve(result === ModalResultEnum.CONFIRM);
            });
        });
    }
}
